"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.equalityComparator = void 0;
var _underscore = require("underscore");
var equalityComparator = exports.equalityComparator = function equalityComparator(prev, next) {
  return (0, _underscore.isEqual)(prev, next);
};